import "./Vision.scss";
import Lines from '../../components/Lines';

const Vision = () => {

    return (
        <>
            <section className="visionAndMission">
                <header>
                    <h2 style={{ color: "#116C4A" }}>Vision & Mission </h2>
                    <span className="lines-parent">
                        <Lines count={25} color="#116C4A" skewDeg={40} fontSize={2.3} spacing={0.1} thickness={700} />
                    </span>
                </header>
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                    <h2>Our Motto</h2>
                    <h3 style={{ fontFamily: "var(--font-h3)", fontSize: "var(--h3-font-size)" }}>
                        "Devotion and Dedication."
                    </h3>
                </div>
            </section>
            <section className="visionPageBgImage">
                <div className="mission-card">
                    <div className="mission-content">
                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                            <h3 className="mission-title">Our Mission</h3>
                            <span><Lines count={4} color="white" skew={-45} fontSize={0.6} spacing={0.1} thickness={500} rotateDeg={90} /></span>
                        </div>
                        <p className="mission-description">Expanding the horizons of knowledge and achieving excellence by creating an atmosphere of  Learning, Research and all round development of our students with a steadfast focus on Empowerment, Engagement and Employability. We will strive to do this by creating a strong fabric of shared  values, Self-Reliance and commitment.</p>
                    </div>
                    <div className="triangle-bottom-right"></div>
                </div>
                <span className="lines-parent" style={{ fontFamily: "Arial" }}>
                    <Lines count={22} color="white" skew={-40} fontSize={2.3} thickness={600} rotateDeg={90} />
                </span>
                <div className="mission-card">
                    <div className="mission-content">
                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                            <h3 className="mission-title">Our Vision</h3>
                            <span><Lines count={4} color="white" skew={-45} fontSize={0.5} spacing={0.1} thickness={500} rotateDeg={90} /></span>
                        </div>
                        <p className="mission-description">Imparting world class education to the youth for their overall development and thereby positively further the Nation’s Economic and Societal Development.</p>
                    </div>
                    <div className="triangle-bottom-right"></div>
                </div>
            </section>
        </>
    )
}

export default Vision
